import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const ChangePassword = () => {
  const navigate = useNavigate();
  const [form, setForm]   = useState({ current_password: '', new_password: '', confirm: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const isForced = localStorage.getItem('ep_password') === '1234';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (form.new_password !== form.confirm) {
      return setError('New passwords do not match.');
    }
    if (form.new_password.length < 4) {
      return setError('New password must be at least 4 characters.');
    }
    setLoading(true);
    try {
      await axios.post('/api/admin/auth/change-password', {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      // Clear stored password — force-change guard will now pass
      localStorage.setItem('ep_password', form.new_password);
      setSuccess('Password changed successfully!');
      setTimeout(() => {
        // Redirect to appropriate dashboard based on role
        const user = JSON.parse(localStorage.getItem('ep_user') || '{}');
        if (user.role === 'super_admin') navigate('/admin/super');
        else if (user.role === 'dealer') navigate('/dealer/dashboard');
        else navigate('/admin/events');
      }, 1200);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to change password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.header}>
          <div style={s.icon}>🔑</div>
          <h1 style={s.title}>Change Password</h1>
          {isForced && (
            <p style={s.forcedNote}>
              Your account is using the default password <strong>"1234"</strong>.<br />
              Please set a new password to continue.
            </p>
          )}
        </div>

        <form onSubmit={handleSubmit} style={s.form}>
          <Field label="Current Password">
            <input
              type="password" style={s.input} placeholder="Enter current password"
              value={form.current_password}
              onChange={e => setForm(f => ({ ...f, current_password: e.target.value }))}
              required
            />
          </Field>
          <Field label="New Password">
            <input
              type="password" style={s.input} placeholder="Min 4 characters"
              value={form.new_password}
              onChange={e => setForm(f => ({ ...f, new_password: e.target.value }))}
              required
            />
          </Field>
          <Field label="Confirm New Password">
            <input
              type="password" style={s.input} placeholder="Repeat new password"
              value={form.confirm}
              onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))}
              required
            />
          </Field>

          {error   && <div style={s.error}>{error}</div>}
          {success && <div style={s.success}>{success}</div>}

          <button type="submit" disabled={loading}
            style={{ ...s.btn, ...(loading ? s.btnDisabled : {}) }}>
            {loading ? 'Saving…' : 'Change Password'}
          </button>

          {!isForced && (
            <button type="button" onClick={() => navigate(-1)} style={s.cancelBtn}>
              Cancel
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

const Field = ({ label, children }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
    <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
      {label}
    </label>
    {children}
  </div>
);

const s = {
  page: { minHeight: '100vh', background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', fontFamily: "'Segoe UI', system-ui, sans-serif" },
  card: { background: '#fff', borderRadius: '1.5rem', padding: '2.5rem', width: '100%', maxWidth: '420px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' },
  header: { textAlign: 'center', marginBottom: '2rem' },
  icon: { fontSize: '2.5rem', marginBottom: '0.5rem' },
  title: { fontSize: '1.75rem', fontWeight: 800, color: '#1a1a2e', margin: '0 0 0.5rem' },
  forcedNote: { background: '#fef9c3', border: '1px solid #fde68a', borderRadius: 8, padding: '0.75rem', color: '#92400e', fontSize: '0.875rem', lineHeight: 1.5, margin: '0.5rem 0 0' },
  form: { display: 'flex', flexDirection: 'column', gap: '1.25rem' },
  input: { padding: '0.75rem 1rem', border: '1.5px solid #e5e7eb', borderRadius: '0.75rem', fontSize: '1rem', outline: 'none' },
  error: { background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '0.5rem', padding: '0.75rem', color: '#dc2626', fontSize: '0.875rem' },
  success: { background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '0.5rem', padding: '0.75rem', color: '#166534', fontSize: '0.875rem' },
  btn: { padding: '0.875rem', background: 'linear-gradient(135deg, #1a1a2e, #0f3460)', color: '#fff', border: 'none', borderRadius: '0.75rem', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' },
  btnDisabled: { opacity: 0.6, cursor: 'not-allowed' },
  cancelBtn: { padding: '0.75rem', background: 'transparent', color: '#888', border: '1.5px solid #e5e7eb', borderRadius: '0.75rem', fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer' },
};

export default ChangePassword;
